import script from "./QuizView.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizView.vue?vue&type=script&setup=true&lang=js"

import "./QuizView.vue?vue&type=style&index=0&id=50b56870&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50b56870"]])

export default __exports__